'use client'

import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getExhibitionOverview, getFeeConfig, getGroupStages, getIndividualStage } from '@/(front-desk)/utils/dataFetch'
import { useSearchParams } from 'next/navigation'
import { handleExhibition } from '@/(front-desk)/store'
import Popup from '@/(front-desk)/components/Popup'
import lscache from 'lscache'

export default function UserExhibitLayout({children}) {

    const searchParams = useSearchParams()
    const serial_no = searchParams.get('serial_no')
    const dispatch = useDispatch()
    const exhibition = useSelector((state) => state.exhibition)
    const global = useSelector((state) => state.global)
    const CMS = useSelector((state) => state.CMS)

    useEffect(() => {
        if (exhibition.overview) {
            console.log('🎪 exhibition: ', exhibition)
        }
    }, [exhibition.overview])

    useEffect(() => {
        if (!serial_no || exhibition.individualProjects === false) {
            dispatch(handleExhibition.actions.setIndividualProject(false))
        }
        else if (exhibition.individualProjects && serial_no) {
            const project = exhibition.individualProjects.find((e) => e.serial_no === serial_no)
            dispatch(handleExhibition.actions.setIndividualProject(project ? project : false))
        }
    }, [serial_no, exhibition.individualProjects])

    // useEffect(() => {
    //     if (global.schoolList === null && global.currentExhibitYear) {
    //         getSchoolList(dispatch, global.currentExhibitYear)
    //     }
    // }, [global.currentExhibitYear])

    useEffect(() => {
        if (exhibition.groupStages === null && global.currentExhibitYear) {
            getGroupStages(dispatch, global.currentExhibitYear)
        }
    }, [exhibition.groupStages, global.currentExhibitYear])

    useEffect(() => {
        if (exhibition.individualStages === null && global.currentExhibitYear) {
            getIndividualStage(dispatch, global.currentExhibitYear)
        }
    }, [exhibition.individualStages, global.currentExhibitYear])

    useEffect(() => {
        if (exhibition.feeConfig === null && global.currentExhibitYear) {
            getFeeConfig(dispatch, global.currentExhibitYear)
        }
    }, [exhibition.feeConfig, global.currentExhibitYear])

    useEffect(() => {
        if (exhibition.overview === null && lscache.get('access') && global.currentExhibitYear) {
            getExhibitionOverview(dispatch, global.currentExhibitYear)
        }
    }, [exhibition.overview, global.currentExhibitYear])

    return (
        <Fragment>
            <title>參展申請 - 放視大賞</title>
            { ![...Object.values(exhibition), global.schoolList].some(e => e === null) &&
                children
            }
            { [exhibition.overview, exhibition.groupStages, exhibition.individualStages].some(e => e === false) &&
                <main className="!mt-[var(--navbar-height)]">
                    <Popup contentClassName="flex-center flex-col gap-4">
                        <div className="title">
                            無法取得參展資訊
                        </div>
                        <div className="text">
                            若問題持續，請聯絡系統管理員 <a className="underline underline-offset-2" href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a>
                        </div>
                    </Popup>
                </main>
            }
        </Fragment>
    )
}
